import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courseslanding',
  templateUrl: './courseslanding.component.html',
  styleUrls: ['./courseslanding.component.css']
})
export class CourseslandingComponent implements OnInit {

  constructor() { }
  logData
  ngOnInit(): void {
    this.logData = localStorage.getItem('logData') ? JSON.parse(localStorage.getItem('logData')): {}
    
  }

}
